export default __webpack_public_path__ + "static/media/17.1ccada13.webp";